import { Component, EventEmitter, Input, Output, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { IssueTrackerTemplateService } from '../../../services/issue-tracker-template.service';
import { IssueTrackerTemplateIncidenceDTO } from '../../../models/issue-tracker-template-dto';

@Component({
  selector: 'app-incidence-template-list',
  templateUrl: './incidence-template-list.component.html',
  styleUrls: ['./incidence-template-list.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class IncidenceTemplateListComponent implements OnInit {

  @Input() idIncidence: string = '';
  @Input() idProject: string = '';
  @Output() onTemplateSelected = new EventEmitter<string>();

  templates: IssueTrackerTemplateIncidenceDTO[] = [];
  selectedTemplate: IssueTrackerTemplateIncidenceDTO | null = null;
  loading = false;

  private toastr = inject(ToastrService);
  private templateService = inject(IssueTrackerTemplateService);

  ngOnInit(): void {
    if (this.idIncidence || this.idProject) {
      this.loadTemplates();
    }
  }

  loadTemplates(): void {
    this.loading = true;
    const request$ = this.idIncidence
      ? this.templateService.getTemplatesByIncidence(this.idIncidence)
      : this.templateService.getTemplatesByProject(this.idProject);

    request$.subscribe({
      next: (data) => {
        this.templates = data;
        this.loading = false;
        if (data.length > 0) {
          this.selectedTemplate = data[0];
        }
      },
      error: (error) => {
        this.loading = false;
        this.toastr.error('Error al cargar las plantillas', 'Error');
        console.error(error);
      }
    });
  }

  selectTemplate(template: IssueTrackerTemplateIncidenceDTO): void {
    this.selectedTemplate = template;
  }

  useTemplate(): void {
    if (this.selectedTemplate) {
      this.onTemplateSelected.emit(this.selectedTemplate.Content);
    }
  }

  hasTemplates(): boolean {
    return this.templates && this.templates.length > 0;
  }
}
